'use client';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import IconLinkedin from '../../../../public/images/icon-linkedin.svg';
import IconTwitter from '../../../../public/images/icon-twitter.svg';
import IconYoutube from '../../../../public/images/icon-youtube.svg';
import IconFacebook from '../../../../public/images/icon-facebook.svg';
import IconInstagram from '../../../../public/images/icon-instagram.svg';
import PublicGallery from 'componentsV2/molecules/Galleries/PublicGallery';

export default function ProviderCapabilities({ provider }) {
  const { t } = useTranslation();

  const {
    about = '',
    cloudServices,
    ComplianceCertifications,
    verticalmarkets,
    galleryLinks,
    dataCenters
  } = provider;

  const isSovereignCloud = dataCenters?.some(
    (el) => el?.sovereignCloudApplication?.contentStatus === 'APPROVED'
  );
  const servicesToShow = isSovereignCloud
    ? cloudServices
        .concat(
          cloudServices[0]?.hasOwnProperty('name')
            ? {
                id: 99999,
                objectId: 99999999999,
                name: 'Sovereign Cloud'
              }
            : {
                id: 99999,
                value: 'Sovereign Cloud',
                label: 'Sovereign Cloud'
              }
        )
        ?.sort((a, b) =>
          a.hasOwnProperty('name')
            ? a.name.localeCompare(b.name)
            : a.label.localeCompare(b.label)
        )
    : cloudServices;

  const allData = [
    { label: t('service_offerings'), data: servicesToShow },
    { label: t('complianceCertifications'), data: ComplianceCertifications },
    { label: t('verticalMarketExpertise'), data: verticalmarkets }
  ]?.filter((e) => e?.data?.length > 0);

  const getUrlByType = (type: string) => {
    const foundObject = provider.socialMedia?.find(
      (item) => item.type === type
    );
    return foundObject ? foundObject.url : null;
  };

  return (
    <div className="flex flex-col gap-10">
      {!!galleryLinks && galleryLinks?.length > 0 && (
        <div className="relative h-[24rem] md:h-[28rem] pb-[2rem]">
          <PublicGallery gallery={galleryLinks} />
        </div>
      )}
      <div className="flex flex-col gap-6">
        <h4 className="p-0 m-0 text-lg font-normal text-[#1f384c]">
          {t('about')}
        </h4>
        <span
          className="text-[#53565a] text-base font-thin leading-7 whitespace-pre-line break-words inline-block"
          dangerouslySetInnerHTML={{
            __html: about?.trim().replace(/<[^>]*>|&nbsp;/g, '')
          }}
        />
      </div>
      {provider?.socialMedia?.length > 0 && (
        <div className={`flex gap-2 items-center ${styles.social_media}`}>
          {['Twitter', 'LinkedIn', 'Instagram', 'Facebook', 'Youtube'].map(
            (type) => {
              const url = getUrlByType(type);
              if (url) {
                const IconComponent = {
                  Twitter: IconTwitter,
                  LinkedIn: IconLinkedin,
                  Instagram: IconInstagram,
                  Facebook: IconFacebook,
                  Youtube: IconYoutube
                }[type];

                return (
                  <a key={type} aria-label={type} target="_blank" href={url}>
                    <IconComponent />
                  </a>
                );
              }
              return null;
            }
          )}
        </div>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {allData.map(({ label, data }, index) => (
          <div key={index} className="flex flex-col gap-4">
            <h3 className="p-0 m-0 text-base font-normal text-[#2360a0]">
              {label}
            </h3>
            <ul className={styles.list_default}>
              {data.map((service, idx) => (
                <li key={`li_item${idx}`}>
                  {service.name ? service.name : service.label}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
